import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlueprintDeployment,
  BlueprintVersionedGroup,
  BlueprintVersionedGroupBlueprintVersionArgs,
  BlueprintVersionedGroupSearchBlueprintVersionsSuggestionsArgs,
  MutationBlueprintDeploymentDeleteArgs,
  SearchBlueprintDeploymentsOutput,
  SearchInput,
} from "types/generated";

type SearchBlueprintVersionedGroupsData = {
  searchBlueprintDeployments: SearchBlueprintDeploymentsOutput;
};

type SearchBlueprintDeploymentsVariables = {
  input: SearchInput;
};

export const SEARCH_TEMPLATE_DEPLOYMENTS: TypedDocumentNode<
  SearchBlueprintVersionedGroupsData,
  SearchBlueprintDeploymentsVariables
> = gql`
  query SearchTemplateDeployments($input: SearchInput!) {
    searchBlueprintDeployments(input: $input) {
      edges {
        node {
          id
          createdAt
          name
          description
          state
          blueprintVersion {
            id
            version
          }
          inputs {
            id
            value
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

type SearchTemplateVersionsSuggestionsData = {
  blueprintVersionedGroup: BlueprintVersionedGroup;
};

export const SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS: TypedDocumentNode<
  SearchTemplateVersionsSuggestionsData,
  BlueprintVersionedGroupBlueprintVersionArgs &
    BlueprintVersionedGroupSearchBlueprintVersionsSuggestionsArgs
> = gql`
  query SearchTemplateVersionsSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    blueprintVersionedGroup(id: $id) {
      id
      searchBlueprintVersionsSuggestions(input: $input) {
        filteredCount
        fields {
          name
          orderable
          filterable
          type
          possibleValuesBoolean {
            values
            counts
          }
          possibleValuesEnum {
            values
            counts
          }
          possibleValuesString {
            values
            counts
          }
          possibleValuesHierarchy {
            values {
              id
              parentId
              displayValue
            }
            counts
          }
        }
      }
    }
  }
`;

type DeleteBlueprintDeploymentData = {
  blueprintDeploymentDelete: Pick<BlueprintDeployment, "id" | "name">;
};

export const DELETE_DEPLOYMENT: TypedDocumentNode<
  DeleteBlueprintDeploymentData,
  MutationBlueprintDeploymentDeleteArgs
> = gql`
  mutation BlueprintDeploymentDelete($blueprintID: ID!, $id: ID!) {
    blueprintDeploymentDelete(blueprintID: $blueprintID, id: $id) {
      id
      name
    }
  }
`;
